export const SEVERITY_LEVELS = ["mild", "moderate", "severe"] as const;
export type Severity = (typeof SEVERITY_LEVELS)[number];

export const SEVERITY_LABELS: Record<Severity, string> = {
  mild: "Mild",
  moderate: "Moderate",
  severe: "Severe",
};
